<template>
  <div id="app">
    <LogoName class="LogoName"></LogoName>
    <SelectIM :cur="curTab" @change-tab="changeTab" class="SelectIM"></SelectIM>
    <router-view />
    <FooterInfo></FooterInfo>
    <div class="space"></div>
  </div>
</template>

<style>
* {
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  overflow: hidden;
}
html,
body {
  background-color: #ffffff;
}
.space {
  height: 44px;
  background-color: #ffffff;
}
</style>

<script>
import LogoName from "@/components/LogoName.vue";
import SelectIM from "@/components/SelectIM.vue";
import FooterInfo from "@/components/FooterInfo.vue";
export default {
  components: {
    LogoName,
    SelectIM,
    FooterInfo
  },
  data() {
    return {
      curTab: "首页"
    };
  },
  methods: {
    changeTab(str) {
      let that = this;
      if (that.curTab == str) {
        return;
      }
      that.curTab = str;
      switch (str) {
        case "首页":
          that.$router.push("/");
          break;
        case "走进世有":
          that.$router.push("/company");
          break;
        case "产品展示":
          that.$router.push("/things");
          break;
        case "成功案例":
          that.$router.push("/project");
          break;
        case "新闻中心":
          that.$router.push("/news");
          break;
        case "售后服务":
          that.$router.push("/aftersale");
          break;
      }
    }
  },
  watch: {
    $route(to) {
      let that = this;
      console.log(to.path);
      if (to.path == "/things") {
        that.curTab = "产品展示";
      }
    }
  },
  mounted() {
    let router_path = this.$route.path;
    let that = this;
    switch (router_path) {
      case "/company/companyintro":
        that.curTab = "走进世有";
        break;
      case "/things":
        that.curTab = "产品展示";
        break;
      case "/project":
        that.curTab = "成功案例";
        break;
      case "/news":
        that.curTab = "新闻中心";
        break;
      case "/aftersale":
        that.curTab = "售后服务";
        break;
    }
  }
};
</script>
